const DEFAULT_NOTARY_WAIT_TIME = 999999;

export function overflowIsTurnedOff(waitTime: number | null): boolean {
  return waitTime === null || waitTime >= DEFAULT_NOTARY_WAIT_TIME;
}
